import React from 'react';

interface CheckboxProps {
  label: string;
  id?: string;
  name?: string;
  onChange?: (checked: boolean) => void;
  isChecked?: boolean;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, id, name, onChange, isChecked }, ref) => (
    <label className="checkbox">
      <input
        type="checkbox"
        ref={ref}
        id={id}
        name={name}
        checked={isChecked}
        onChange={onChange ? e => onChange(e.target.checked) : undefined}
      />
      <i />
      <span>{label}</span>
    </label>
  ),
);
